<template>
  <div class="p-6 flex-grow-1 container-p-y" id="mikrotik">
    <div class="row g-6">
      <!-- <div class="text-center">
        <h2 class="mb-2 mt-5">Mikrotik</h2>
      </div> -->
      <div class="col-xl-6 settings-card">
        <div
          class="card p-7"
          :class="
            mikrotik.auto_reboot
              ? 'card-border-shadow-success'
              : 'card-border-shadow-danger'
          "
        >
          <div class="d-flex align-items-center row settings-card-container">
            <div class="col-8">
              <div class="card-body text-nowrap settings-card-text">
                <h3 class="card-title mb-0">
                  {{ $t("mikrotik.titles.auto_reboot") }}
                </h3>
                <h4
                  class="mb-md-7"
                  :class="mikrotik.auto_reboot ? 'text-success' : 'text-danger'"
                >
                  {{ $t("mikrotik.auto_reboot") }}
                </h4>
                <button
                  @click="
                    mikrotik.auto_reboot = !mikrotik.auto_reboot;
                    store();
                  "
                  type="button"
                  class="btn btn-lg "
                  :class="mikrotik.auto_reboot ? 'btn-success' : 'btn-danger'"
                >
                  <span
                    class="ti-lg ti me-4"
                    :class="
                      mikrotik.auto_reboot ? 'ti-square-check' : 'ti-square-x'
                    "
                  ></span>
                  {{
                    mikrotik.auto_reboot
                      ? $t("control.enabled")
                      : $t("control.disabled")
                  }}
                </button>
              </div>
            </div>
            <div class="col-4 text-center text-sm-left">
              <img
                src="@/assets/img/mikrotik/reboot-e.png"
                class="image-e"
                height="140"
                alt="view sales"
                v-if="mikrotik.auto_reboot"
              />
              <img
                v-else
                src="@/assets/img/mikrotik/reboot-d.png"
                class="image-d"
                height="140"
                alt="view sales"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 settings-card">
        <div
          class="card p-7"
          :class="
            mikrotik.whatsapp_messages
              ? 'card-border-shadow-success'
              : 'card-border-shadow-danger'
          "
        >
          <div class="d-flex align-items-center row settings-card-container">
            <div class="col-8">
              <div class="card-body text-nowrap settings-card-text">
                <h3 class="card-title mb-0">
                  {{ $t("mikrotik.titles.whatsapp_messages") }}
                </h3>
                <h4
                  class=" mb-md-7"
                  :class="
                    mikrotik.whatsapp_messages ? 'text-success' : 'text-danger'
                  "
                >
                  {{ $t("mikrotik.whatsapp_messages_only") }}
                </h4>
                <button
                  @click="
                    mikrotik.whatsapp_messages = !mikrotik.whatsapp_messages;
                    store();
                  "
                  type="button"
                  class="btn btn-lg "
                  :class="
                    mikrotik.whatsapp_messages ? 'btn-success' : 'btn-danger'
                  "
                >
                  <span
                    class="ti-lg ti me-4"
                    :class="
                      mikrotik.whatsapp_messages
                        ? 'ti-square-check'
                        : 'ti-square-x'
                    "
                  ></span>
                  {{
                    mikrotik.whatsapp_messages
                      ? $t("control.enabled")
                      : $t("control.disabled")
                  }}
                </button>
              </div>
            </div>
            <div class="col-4 text-center text-sm-left">
              <img
                src="@/assets/img/mikrotik/wa-e.png"
                class="image-e"
                height="140"
                alt="view sales"
                v-if="mikrotik.whatsapp_messages"
              />
              <img
                v-else
                src="@/assets/img/mikrotik/wa-d.png"
                class="image-d"
                height="140"
                alt="view sales"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 settings-card">
        <div
          class="card p-7"
          :class="
            mikrotik.whatsapp_full
              ? 'card-border-shadow-success'
              : 'card-border-shadow-danger'
          "
        >
          <div class="d-flex align-items-center row settings-card-container">
            <div class="col-8">
              <div class="card-body text-nowrap settings-card-text">
                <h3 class="card-title mb-0">
                  {{ $t("mikrotik.titles.whatsapp_full") }}
                </h3>
                <h4
                  class=" mb-md-7"
                  :class="
                    mikrotik.whatsapp_full ? 'text-success' : 'text-danger'
                  "
                >
                  {{ $t("mikrotik.whatsapp_full") }}
                </h4>
                <button
                  @click="
                    mikrotik.whatsapp_full = !mikrotik.whatsapp_full;
                    store();
                  "
                  type="button"
                  class="btn btn-lg "
                  :class="mikrotik.whatsapp_full ? 'btn-success' : 'btn-danger'"
                >
                  <span
                    class="ti-lg ti me-4"
                    :class="
                      mikrotik.whatsapp_full ? 'ti-square-check' : 'ti-square-x'
                    "
                  ></span>
                  {{
                    mikrotik.whatsapp_full
                      ? $t("control.enabled")
                      : $t("control.disabled")
                  }}
                </button>
              </div>
            </div>
            <div class="col-4 text-center text-sm-left">
              <img
                src="@/assets/img/mikrotik/wa-e.png"
                class="image-e"
                height="140"
                alt="view sales"
                v-if="mikrotik.whatsapp_full"
              />
              <img
                v-else
                src="@/assets/img/mikrotik/wa-d.png"
                class="image-d"
                height="140"
                alt="view sales"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 settings-card">
        <div
          class="card p-7"
          :class="
            mikrotik.custom_dns
              ? 'card-border-shadow-success'
              : 'card-border-shadow-danger'
          "
        >
          <div class="d-flex align-items-center row settings-card-container">
            <div class="col-8">
              <div class="card-body text-nowrap settings-card-text">
                <h3 class="card-title mb-0">
                  {{ $t("mikrotik.titles.protection") }}
                </h3>
                <h4
                  class="mb-md-7"
                  :class="mikrotik.custom_dns ? 'text-success' : 'text-danger'"
                >
                  {{ $t("mikrotik.dns") }}
                </h4>
                <button
                  type="button"
                  @click="
                    mikrotik.custom_dns = !mikrotik.custom_dns;
                    store();
                  "
                  class="btn btn-lg"
                  :class="mikrotik.custom_dns ? 'btn-success' : 'btn-danger'"
                >
                  <span
                    class="ti-lg ti me-4"
                    :class="
                      mikrotik.custom_dns ? 'ti-square-check' : 'ti-square-x'
                    "
                  ></span>
                  {{
                    mikrotik.custom_dns
                      ? $t("control.enabled")
                      : $t("control.disabled")
                  }}
                </button>
              </div>
            </div>
            <div class="col-4 text-center text-sm-left">
              <img
                src="@/assets/img/mikrotik/shield-e.png"
                class="image-e"
                height="140"
                alt="view sales"
                v-if="mikrotik.custom_dns"
              />
              <img
                src="@/assets/img/mikrotik/shield-d.png"
                class="image-d"
                height="140"
                alt="view sales"
                v-else
              />
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="d-grid gap-2 col-lg-6 mx-auto">
        <button
          class="btn btn-primary btn-lg"
          @click.prevent="store"
          type="button"
          :disabled="applied"
        >
          {{ applied ? $t("settings.applied") : $t("settings.apply") }}
        </button>
        <div v-if="applying">Loading...</div>
      </div> -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Mikrotik",
  async created() {
    this.loading = true;
    const response = await axios.get("mikrotik");
    if (response.status == 200) {
      let temp = response.data.data;
      temp.forEach((element) => {
        switch (element.key) {
          case "mikrotik_auto_reboot":
            this.mikrotik.auto_reboot = element.value;
            break;
          case "mikrotik_custom_dns":
            this.mikrotik.custom_dns = element.value;
            break;
          case "mikrotik_whatsapp_messages":
            this.mikrotik.whatsapp_messages = element.value;
            break;
          case "mikrotik_whatsapp_full":
            this.mikrotik.whatsapp_full = element.value;
            break;
          case "mikrotik_open_speed":
            this.mikrotik.open_speed = element.value;
            break;
        }
      });
    }
    this.loading = false;
  },
  data() {
    return {
      error: "",
      message: "",
      currentImageUrl: null,
      mikrotik: {
        auto_reboot: false,
        custom_dns: false,
        whatsapp_messages: false,
        whatsapp_full: false,
        open_speed: false,
      },
      mikrotik_auto_reboot: false,
      whatsapp_messages_only: false,
      whatsapp_full: false,
      dns: false,
      open_speed: false,
      loading: false,
      applying: false,
      applied: false,
      profiles: null,
      start_time: {
        hours: 2,
        minutes: 0,
      },
      stop_time: {
        hours: 6,
        minutes: 0,
      },
    };
  },
  methods: {
    selectImage() {
      this.setting.network_logo = this.$refs.imageFile.files.item(0);
      this.currentImageUrl = URL.createObjectURL(this.setting.network_logo);
    },
    async store() {
      this.applying = true;
      const response = await axios.post("/mikrotik", this.mikrotik);
      if (response.status == 200) {
        this.applying = false;
        this.applied = true;
        this.$router.push({ query: { success: "success" } });
      }
    },
  },
};

// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll(".settings-card").forEach((card) => {
//     const button = card.querySelector(".btn-success, .btn-danger");
//     const text = card.querySelector("h4");
//     const outerCard = card.querySelector(".card");
//     const imageE = card.querySelector(".image-e");
//     const imageD = card.querySelector(".image-d");

//     button.addEventListener("click", () => {
//       const isActivated = button.classList.contains("btn-success");
//       button.classList.toggle("btn-success", !isActivated);
//       button.classList.toggle("btn-danger", isActivated);
//       button.innerHTML = `<span class="ti-lg ti ${
//         isActivated ? "ti ti-square-x" : "ti ti-square-check"
//       } me-4"></span>${isActivated ? $t('control.disabled') : $t('control.enabled')}`;
//       outerCard.classList.toggle("card-border-shadow-success", !isActivated);
//       outerCard.classList.toggle("card-border-shadow-danger", isActivated);
//       text.classList.toggle("text-success", !isActivated);
//       text.classList.toggle("text-danger", isActivated);
//       imageE.classList.toggle("d-none", isActivated);
//       imageD.classList.toggle("d-none", !isActivated);
//     });
//   });
// });
</script>
